import { MUITextField } from "@abb/arcadia-ui-react"
import { zodResolver } from "@hookform/resolvers/zod"
import { StatusCodes } from "http-status-codes"
import { useCallback, useEffect } from "react"
import { Controller, ControllerRenderProps, useForm } from "react-hook-form"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { z } from "zod"
import { digitalManagerApi } from "../../../../services/api"
import { FieldRow, FormPage } from "../../../components/FormPage"

const validationSchema = z.object({
  name: z.string().min(1, "Name is required"),
})

const returnURL = `/devices#categories`

export function CategoryCreate() {
  const navigate = useNavigate()

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting, isDirty, isValid },
  } = useForm<{ name: string }>({
    resolver: zodResolver(validationSchema),
    mode: "onChange",
  })

  useEffect(() => {
    reset({
      name: "",
    })
  }, [reset])

  const onSubmit = useCallback(
    (values: { name: string }) => digitalManagerApi
        .post(`/deviceCategories`, {
          name: values.name,
        })
        .then((res) => {
          if (res.status === StatusCodes.CREATED) {
            toast.success("Device Category created")
            navigate(returnURL)
          }
        })
        .catch(() => {
          toast.error("Cannot create device categories")
        }),
    [navigate]
  )

  const handleNameFieldChange = useCallback(
    (field: ControllerRenderProps<{ name: string }, "name">) => (value: string) =>
      field.onChange(value),
    []
  )

  const renderNameTextField = useCallback(
    (props: { field: ControllerRenderProps<{ name: string }, "name"> }) => {
      const { field } = props

      return (
        <MUITextField
          id="name"
          type="text"
          size={32}
          name={field.name}
          value={field.value}
          onChange={handleNameFieldChange(field)}
          onBlur={field.onBlur}
          isDisabled={isSubmitting}
          errors={
            typeof errors.name?.message === "string"
              ? { name: { message: errors.name.message } }
              : undefined
          }
        />
      )
    },
    [errors.name, handleNameFieldChange, isSubmitting]
  )

  return (
    <FormPage
      returnURL={returnURL}
      onSubmit={handleSubmit(onSubmit)}
      isSubmitting={isSubmitting}
      isDirty={isDirty}
      isValid={isValid}
    >
      <FieldRow label="Name">
        <Controller name="name" control={control} render={renderNameTextField} />
      </FieldRow>
    </FormPage>
  )
}
